/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![StageXIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAC7klEQVR4nMVV30tUURA2CLUgMqIsKHq0+heilqJgyT0zc4W7M2qxgmQEgj301A8oUmgjqj+g+gcqQqIe+iFJ9NKLlUIRZVFBFlQkKvYgxtw7Z/eu7V4Ngg4c2HPPOfN9M9+cb+vq/ucIw3A1YvthQLkJyO+BZNqhzDiSd0B8wxH3AMCqvw6cKRQaHfIpIJ4Ckvn0yT/1bBiG9UsKvr+tY4sjHikFQH7okLuJeJtmpOC5tvatQHLIkQyVz8kzRN6cGlwPAMknveBQ3uSoPbMYIUTeCciv4zv8sSZINpttAOLn0UGSJ4iFpiijMNwAJAOO+IVD+QUks3rOofQ7J816RjMD5MfxXR7RWH8AOOTTnrkP7kjyjmQytf4k+TiTQpPPBEhOVgRXBqVAkN9lqbNDnjNWgwD53doxYRiucIHsAZS7VpY5D6J3rQKTFd3liI/YxpCug6Bzo7Izlidq1V/3SplYuYDkgZHqSQIMGptuOzRgnXHbMqx3KOcB5TMQTwBxMZPJLLe7d+zuWSt1lwFcLzOJH9E8QNhizGKxA9ln6wtVNDhnZdnrxY3XYYu199tEqtoZMp/L5VbGLGRG162tHWsMYKKKwBO6R3RwrX2b1rXGsP2pJMB0NQAV39bfagFoqRYEXAYk4w75S0ID+VCjRFlbX6oCUExo2KsvvlYzaIBbJlSXMe63uvaWRCa+CMTfbRaX7D06IseMhbnn6+qQj3sNUogVHcn9IDiw3n/LhuG6yL9IriUACk3eOV1bfkcySKZQaATiPkB5qs3giH/4l66ErFxj+g4USC3F3tRwBZvYniOruOy/BUHnJn8hOXPIxzzb8j6PxTP+ncyqxNShnAEIt0eXs9mGasFtznqnrQSJyvxSnWBRXRzK0ZQ/mpoAjuSVOvCiAGoTKS7aVxZURheWSAF1Lz0DYqz1l6namMiPzLNGI4GdNJd0SHsXfmi3qNOaGY5HloLy1RsdkFxRB04KGneSDDvkq4sC/IvxG5BJLDqrdTaxAAAAAElFTkSuQmCC)
 */
export const StageXIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M22.34 13.02c.31.03.63-.17.65-.49L23 12a11 11 0 1 0-20.09 6.2c.34.5 1.05.51 1.46.07l.02-.02c.33-.36.34-.91.07-1.33A9 9 0 1 1 21 12.36c-.01.38.37.68.75.65.2-.02.4-.01.6 0Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M12.6 16.03c.23.02.4.23.44.46.1.6.38 1.17.84 1.63l.52.53c.2.2.2.5 0 .7l-.52.53a3 3 0 0 0-.86 2.46c.03.31-.17.63-.49.65a11.16 11.16 0 0 1-5.4-1.12 1.52 1.52 0 0 1-.8-1.84 6 6 0 0 1 6.26-4ZM13.13 14.78A3 3 0 0 1 9 12a3 3 0 1 1 4.13 2.78Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M18.79 13.71c-.08.3-.45.39-.67.17a3 3 0 0 0-.81-.58.62.62 0 0 1-.35-.63c.02-.22.04-.44.04-.67a5 5 0 1 0-9.6 1.94c.17.42.13.9-.18 1.23l-.05.06c-.43.47-1.18.42-1.45-.14a7 7 0 1 1 13.07-1.38ZM16.7 15.3a1 1 0 0 0-1.4 1.4l2.29 2.3-2.3 2.3a1 1 0 0 0 1.42 1.4L19 20.42l2.3 2.3a1 1 0 0 0 1.4-1.42L20.42 19l2.3-2.3a1 1 0 0 0-1.42-1.4L19 17.58l-2.3-2.3Z"
        className={colorClass}
      />
    </svg>
  );
};
